import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import "./level.css";
import Table from "./components/Table";
import ExportToExcel from "../../../components/ExportToExcel";
import Header from "../../../components/Header";
import Loader from "../../../components/Loader";
import { ErrorState, EmptyState } from "../../../components/PageState";
import { API_BASE_URL, authFetch } from "../../../config/api";

function ErrorStudents() {
  const target = useRef();
  const { level, session, _id } = useParams();
  const [students, setStudents] = useState([]);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState(null);

  const fetchStudents = useCallback(async () => {
    setLoad(true);
    setError(null);
    try {
      let json;
      try {
        const params = new URLSearchParams({ class_id: _id, level });
        const res = await authFetch(
          `${API_BASE_URL}/api/class/error?${params}`,
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const text = await res.text();
        if (text.trim().startsWith("<")) throw new Error("HTML response");
        json = JSON.parse(text);
      } catch {
        // error students offline query not implemented yet — show empty
        json = { students: [] };
      }
      setStudents(json.students || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoad(false);
    }
  }, [_id, level]);

  useEffect(() => {
    fetchStudents();
  }, [fetchStudents]);

  return (
    <>
      <Header />
      <div
        className="current_level"
        ref={target}
        id="pageContent"
        style={{ textAlign: "center" }}
      >
        <div className="header">
          <h2>
            {session}: {level} error students list
          </h2>
        </div>
        {load && <Loader />}
        {error && <ErrorState message={error} onRetry={fetchStudents} />}
        {!load && !error && students.length === 0 && (
          <EmptyState message="No error students found for this class." />
        )}
        {students.length > 0 && <Table students={students} />}
      </div>
      <div className="gp_tab no_print">
        <div className="transcript_btn">
          <button onClick={() => window.print()}>Print</button>
        </div>
        <div>
          <ExportToExcel
            tableId="myTable"
            filename={`${session}: ${level} Level: error students list`}
          />
        </div>
      </div>
    </>
  );
}

export default ErrorStudents;
